import angular from 'angular';
// installs window.L
import 'mapbox.js';
import {} from 'mapbox.js/theme/style.css';

module.exports = angular.module('common.values.mapbox', [])
.value('MapboxConfig', {
  // Public token; meant to be exposed client-side.
  // URL restrictions are configured in the Mapbox admin panel.
  accessToken: 'pk.eyJ1Ijoib3BlbmRvb3IiLCJhIjoiY21tNDNwdmE4MDZsaDJvcG4zYXE4c254NyJ9.5PjzJ7pYIrbodyh1USA5ag', // eslint-disable-line max-len
  defaultMap: 'mapbox.satellite'
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/values/mapbox-config.js
 **/